import { WEB_SOCKET_RECEIVED } from "../constants/webSocketConstants";

export const receiveWebSocket =
	(message) => {
        
        return {
            type: WEB_SOCKET_RECEIVED,
            payload: message,
          };
        };